import React from 'react';
import Input from '../common/Input';
import Select from '../common/Select';
import { propertyTypes, states } from '../../data/propertyTypes';
import { useContract } from '../../context/ContractContext';

const PropertyForm = () => {
  const { contractData, updateContractData } = useContract();
  const { property } = contractData;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    updateContractData('property', {
      [name]: type === 'checkbox' ? checked : value
    });
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-dark-900 mb-4">
          Dados do Imóvel
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Select
            label="Tipo do Imóvel"
            name="type"
            value={property.type || ''}
            onChange={handleChange}
            options={propertyTypes}
            required
          />
          
          <Input
            label="CEP"
            name="zipCode"
            value={property.zipCode || ''}
            onChange={handleChange}
            mask="99999-999"
            placeholder="00000-000"
            required
          />
        </div>

        <div className="mt-6">
          <Input
            label="Endereço Completo"
            name="address"
            value={property.address || ''}
            onChange={handleChange}
            placeholder="Rua, número, complemento"
            required
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          <Input
            label="Cidade"
            name="city"
            value={property.city || ''}
            onChange={handleChange}
            required
          />
          
          <Select
            label="Estado"
            name="state"
            value={property.state || ''}
            onChange={handleChange}
            options={states}
            required
          />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
          <Input
            label="Área (m²)"
            name="area"
            type="number"
            value={property.area || ''}
            onChange={handleChange}
            placeholder="0"
          />
          
          <Input
            label="Quartos"
            name="bedrooms"
            type="number"
            value={property.bedrooms || ''}
            onChange={handleChange}
            placeholder="0"
          />
          
          <Input
            label="Banheiros"
            name="bathrooms"
            type="number"
            value={property.bathrooms || ''}
            onChange={handleChange}
            placeholder="0"
          />
          
          <Input
            label="Vagas Garagem"
            name="parking"
            type="number"
            value={property.parking || ''}
            onChange={handleChange}
            placeholder="0"
          />
        </div>

        <div className="mt-6">
          <div className="flex items-center">
            <input
              type="checkbox"
              id="furnished"
              name="furnished"
              checked={property.furnished || false}
              onChange={handleChange}
              className="h-4 w-4 text-primary-500 focus:ring-primary-500 border-neutral-300 rounded"
            />
            <label htmlFor="furnished" className="ml-2 block text-sm font-medium text-dark-800">
              Imóvel mobiliado/semi-mobiliado
            </label>
          </div>
        </div>

        <div className="mt-6">
          <label htmlFor="description" className="block text-sm font-medium text-dark-800 mb-2">
            Descrição Adicional
          </label>
          <textarea
            id="description"
            name="description"
            rows={3}
            value={property.description || ''}
            onChange={handleChange}
            className="input"
            placeholder="Descreva características adicionais do imóvel..."
          />
        </div>
      </div>
    </div>
  );
};

export default PropertyForm;